import { render, staticRenderFns } from "./edit-blobs.vue?vue&type=template&id=b94bbda2&scoped=true&"
import script from "./edit-blobs.vue?vue&type=script&lang=js&"
export * from "./edit-blobs.vue?vue&type=script&lang=js&"
import style0 from "./edit-blobs.vue?vue&type=style&index=0&id=b94bbda2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94bbda2",
  null
  
)

export default component.exports